'use client';

import { queryOptions, useSuspenseQuery, UseSuspenseQueryResult } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { commentsOptions } from '@/api/queries/comments';
import { CommentDTO, MetaDataParams } from '@/types/models';
export function useComments(): UseSuspenseQueryResult<CommentDTO[]> {
  const params = useParams<MetaDataParams>();
  const id = params.slug?.[0] || params.id;
  return useSuspenseQuery(queryOptions(commentsOptions(id as string)));
}